// components/ComnetariosSection.tsx

import { useEffect, useState } from 'react';
import { Trash2 } from 'lucide-react';

import {
    DataTableColumn,
} from '@/presentation/components/common/DataTable';
import { IconButton } from '@/presentation/components/common/IconButton/IconButton';
import { useCongrupo } from '@/presentation/hooks/useCongrupo';
import { useSimple } from '@/presentation/hooks/useSimple';
import { useAuthContext } from '@/presentation';
import { ActionSection } from './ActionSection';
import { CreateDialog } from './CreateActionDialog';
import { DeleteActionDialog } from './DeleteActionDialog';
import { Form } from '@/presentation/components/Forms/Form/Form';
import { formatSmartDateTime } from '@/shared/utils/dateFormaters';

interface ActionItem {
    id: number;
    nombre: string;
    usuario: string;
    fecha: Date;
}

interface ComnetariosSectionProps {
    incidenteId: string;
}

export function ComnetariosSection({
    incidenteId,
}: ComnetariosSectionProps) {
    const { user } = useAuthContext();
    const [createOpen, setCreateOpen] =
        useState(false);

    const [deleteOpen, setDeleteOpen] =
        useState(false);

    const [selectedId, setSelectedId] =
        useState<number | null>(null);



    const { remove } =
        useSimple('luc_comentarios');

    const {
        data: Comnetarios,
        loadByGroup,
        create,
    } = useCongrupo();

    const loadComnetarios = async () => {
        await loadByGroup(
            'luc_comentarios',
            incidenteId
        );
    };

    useEffect(() => {
        loadComnetarios();
    }, [incidenteId]);


    const columns: DataTableColumn<ActionItem>[] =
        [
            {
                key: 'nombre',
                header: 'Detalle',
            },
            {
                key: 'usuario',
                header: 'Usuario',
            },
            {
                key: 'fecha',
                header: 'Fecha',
                render: (item) =>
                        formatSmartDateTime(item.fecha),
            },
            {
                key: 'eliminar',
                header: '',
                render: (item) => (
                    <IconButton
                        icon={<Trash2 size={30} />}
                        title="Eliminar"
                        color="danger"
                        onClick={() => {
                            setSelectedId(item.id);
                            setDeleteOpen(true);
                        }}
                    />
                ),
            },
        ];

    const handleOpenCreate = async () => {

        setCreateOpen(true);
    };

    const handleCreate = async (
        values: Record<string, unknown>
    ) => {
        await create('luc_comentarios', {
            nombre: String(values.nombre),
            grupo: incidenteId,
            usuario: String(user?.id),
            fecha: new Date()
        });

        setCreateOpen(false);
        await loadComnetarios();
    };

    const handleDelete = async () => {
        if (selectedId === null) return;

        await remove(selectedId);

        setDeleteOpen(false);
        setSelectedId(null);

        await loadComnetarios();
    };

    return (
        <>
            <ActionSection
                title="Comentarios"
                buttonLabel="Nuevo Comentario"
                data={Comnetarios}
                columns={columns}
                emptyMessage="No hay Comnetarios cargadas"
                onCreate={handleOpenCreate}
            />

            <CreateDialog
                open={createOpen}
                title="Nueva Falla"
                onClose={() => setCreateOpen(false)}
            >
                <Form
                    fields={[
                        {
                            name: "nombre",
                            type: "textarea",
                            label: "Comentario",
                        },
                    ]}
                    submitLabel="Agregar"
                    onSubmit={handleCreate}
                />
            </CreateDialog>

            <DeleteActionDialog
                open={deleteOpen}
                title="Eliminar Comentario"
                message="¿Seguro que quiere eliminar el comentario?"
                onClose={() => setDeleteOpen(false)}
                onConfirm={handleDelete}
            />
        </>
    );
}